export default __webpack_public_path__ + "static/media/cloudbees.e2f32d20.png";